import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-event-requests',
  templateUrl: './event-requests.component.html',
  styleUrls: ['./event-requests.component.css'],
})
export class EventRequestsComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
